import { create } from 'zustand';

interface ChatState {
    isChatOpen: boolean;
    isChatLoaded: boolean;
}

interface ChatActions {
    toggleChat: (value?: boolean) => void;
    toggleChatLoaded: (value?: boolean) => void;
}

type ChatStore = ChatState & ChatActions;

const initialState: ChatState = {
    isChatOpen: false,
    isChatLoaded: false,
};

export const useChatStore = create<ChatStore>()((set, get) => ({
    ...initialState,
    toggleChat: (value) => {
        const newValue = typeof value === 'boolean' ? value : !get().isChatOpen;

        set({
            isChatOpen: newValue,
        });
    },
    toggleChatLoaded: (value) => {
        const newValue = typeof value === 'boolean' ? value : !get().isChatOpen;

        set({
            isChatLoaded: newValue,
        });
    },
}));
